// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"7171":"9b7a9602","7280":"fea60f39"}[chunkId] + ".chunk.css";
};